/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    RewardConfigResponse,
    RewardConfigResponseFromJSON,
    RewardConfigResponseFromJSONTyped,
    RewardConfigResponseToJSON,
    WinningCriteria,
    WinningCriteriaFromJSON,
    WinningCriteriaFromJSONTyped,
    WinningCriteriaToJSON,
} from './';

/**
 * Collection contains the user\'s reward stats/progress.
 * @export
 * @interface SponsoredRewardResponse
 */
export interface SponsoredRewardResponse {
    /**
     * 
     * @type {WinningCriteria}
     * @memberof SponsoredRewardResponse
     */
    winningCriteria: WinningCriteria;
    /**
     * 
     * @type {RewardConfigResponse}
     * @memberof SponsoredRewardResponse
     */
    rewardConfig: RewardConfigResponse;
}

export function SponsoredRewardResponseFromJSON(json: any): SponsoredRewardResponse {
    return SponsoredRewardResponseFromJSONTyped(json, false);
}

export function SponsoredRewardResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): SponsoredRewardResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'winningCriteria': WinningCriteriaFromJSON(json['winningCriteria']),
        'rewardConfig': RewardConfigResponseFromJSON(json['rewardConfig']),
    };
}

export function SponsoredRewardResponseToJSON(value?: SponsoredRewardResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'winningCriteria': WinningCriteriaToJSON(value.winningCriteria),
        'rewardConfig': RewardConfigResponseToJSON(value.rewardConfig),
    };
}


